import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./../consultaNominas/consultaNominas.scss";
import { memo } from "react";
import React, { useState } from "react";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";

registerLocale("es", es);

const ModalShowUsuarioAlta = (object) => {

  // const [token] = useLocalStorage("token", "");
  // const [ setLoading] = useState(false);
  
  // const [mensaje, setMensaje] = useState();
  const [showConfirm] = useState(false);
 



  // useEffect(() => {
  //   setLoading(true);
  // }, [token]);

  function modalShowUsuario() {
    return (
      <Modal
        className={`infModal fechas ${showConfirm ? "opacity-0" : "opacity-100"
          } `}
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Se ha dado de alta al siguiente usuario"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Se ha dado de alta al siguiente usuario</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container containerTablaAltaUsuario">
            <div className="tabla">
              <DataTable
                className="table-reponsive"
                columns={ConstantesTabla.columnasModalAlta}
                data={[object?.usuario]}
                pagination={false}
                paginationComponentOptions={
                  ConstantesTabla.paginacionOpt
                }
                noDataComponent={
                  <span></span>
                }
                customStyles={ConstantesTabla.customStyles}

              />
            </div>
            
            <div className="mensajeAviso p-4">
                <span>AVISO: Recuerde anotar el nombre de usuario y la contraseña para comunicarselo al usuario final.</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalShowUsuario()}</>;
};

export default memo(ModalShowUsuarioAlta);
